import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useTasksTriggersPage() {
  const { t } = useTranslation('maintenance');

  const tabLabels = useMemo(
    () => ({
      tasks: t('tasksTriggers.tasksTab'),
      triggers: t('tasksTriggers.triggersTab'),
    }),
    [t],
  );

  return { tabLabels };
}
